{
  "version": 1,
  "asset_id": "2edcec8f-cb66-44d0-81f5-75fb47cbab3f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2edcec8f-cb66-44d0-81f5-75fb47cbab3f/svc-content-strategy-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2edcec8f-cb66-44d0-81f5-75fb47cbab3f/svc-content-strategy-1200.webp",
  "original_filename": "svc-content-strategy-1200.webp",
  "size": 20904,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:42Z"
}
